import React from 'react'
import RegisterUser from "../../../components/Register/RegisterUser";

const Eu = () => (
    <RegisterUser type="Eu"/>
)

export default Eu
